import defaultBorders from './Borders';
import defaultColors from './Colors';

const colors = {
  ...defaultColors,
  grayscale: {
    black: '#FFFFFF',
    gray0: '#D9D9D6',
    gray1: '#F8F8F8',
    gray2: '#BABABA',
    gray3: '#75787B',
    gray4: '#53565A',
    white: '#000000',
  },
};

const borders = {
  ...defaultBorders,
  borderBlack1: `border: 1px solid ${colors.grayscale.black}`,
};

export default {
  borders,
  colors,
};
